<template lang="pug">
  .classifier.garbage
    div
      e-toolbar(
        :items="items"
        :hideRemoveButton="true"
        :hideAddButton="true"
        :showViewPanel="false"
        :showYear="true"
        :showUnit="hasGarbageUnits"
        :hideImportBtn="true"
      )
        div(slot="searchResult").parameter.parameter--right
          e-form-group(
            inputType="select"
            :inputStyle="{'width':'auto'}"
            :formValidator="formValidator"
            label="Группировать по"
            name="_groupBy"
            :model="filterModel"
            tabView="tab1"
            :options="groupByOptions"
            @change="changeGroupedBy"
          ).filter-block

      e-table(
        v-if="filterModel._groupBy !== 'garbage_type'"
        :items="groupedItems"
        :showDeleteButton="false"
        :showEditButton="false"
        :showCheckbox="false"
        :showPagination="false"
        :fullWidthTr="fullWidthTr"
        :trClass="trClass"
        class="table_static-last-child"
        ref="table"
      )
        template(slot="fullWidthTr" slot-scope="props")
          td(
            :colspan="props.colspan"
            @click="toggleBlock(props.row)"
          )
            div
              button.arrow.reset-btn
              span {{props.row.block}}
                span.red-color(v-if="hasGarbagePercent" v-html='calculatePercentGarbage(props.row[filterModel.groupContextAttr])' style="padding-left:15px")
        template(slot="block" slot-scope="props")
          div.fkko-block.table-garbage.display-flex
            div.fkko-name-wrapper.fkko-name-wrapper-garbage.fkko-block__item
              div.fkko-name {{props.row.fkko_name}}
            div.fkko-block__item
              span {{props.row.fkko_code}}
              div.reg-code.fkko-block__reg-code(v-if="hasGarbageRegCode" ) {{props.row.reg_code}}
      type-table(v-else :items='typeItems')
</template>

<script>
import { cadastr } from '@/api/api-endpoints'
import url from '@/utils/url'
import FormValidator from '@/components/form/form-validator'
import TypeTable from './components/type-table'
import hasMixin from '@/mixins/has-mixin'

const GROUP_BY_FKKO = 'fkko'
const GROUP_BY_DANGER = 'danger'
const GROUP_BY_GARBAGE_TYPE = 'garbage_type'

export default {
  name: 'garbage',
  components: { TypeTable },
  mixins: [hasMixin],
  data() {
    this.formValidator = new FormValidator()
    return {
      openedRows: [],
      filterModel: {
        _groupBy: GROUP_BY_FKKO,
        groupContextAttr: 'fkko_group_id',
      },
    }
  },
  computed: {
    groupByOptions() {
      const arr = [
        { id: GROUP_BY_FKKO, name: 'ФККО' },
        { id: GROUP_BY_DANGER, name: 'Классу опасности' },
      ]
      if (this.hasGarbageGroupByType) {
        arr.push({
          id: GROUP_BY_GARBAGE_TYPE,
          name: 'Категориям отходо образователей',
        })
      }
      return arr
    },
    searchFoundedItemsIds() {
      let searchFoundedItems = this.searchFoundedItems || []
      let ids = []
      searchFoundedItems.forEach((v) => {
        ids.push(v.id)
      })
      // if no search, for show empty list
      if (this.$route.query.q && ids.length === 0) {
        return [-1]
      }
      return ids
    },
    groupedItems() {
      let rows = []
      if (this.filterModel._groupBy === GROUP_BY_DANGER) {
        rows = this.itemsGroupedByDanger
      } else if (this.filterModel._groupBy === GROUP_BY_GARBAGE_TYPE) {
        rows = this.itemsGroupedByGarbageType
      } else {
        rows = this.itemsGroupedByFkko
      }
      let sort = {}
      if (this.$route.query.sort) {
        if (this.$route.query.sort.startsWith('-')) {
          sort[this.$route.query.sort.substring(1)] = 'desc'
        } else {
          sort[this.$route.query.sort] = 'asc'
        }
      } else {
        sort = { fkko_code: 'asc' }
      }
      return {
        data: rows,
        _meta: {
          fields: this.items._meta.fields,
          sort,
        },
      }
    },
    itemsGroupedByFkko() {
      let groupedKey = 'fkko_group_id'
      let primaryKeyName = 'fkko_id'
      let data = this.items.data
      let searchFoundedItemsIds = this.searchFoundedItemsIds
      let blockName = (current) => current.fkko_group_name
      return this.groupItems(data, searchFoundedItemsIds, {
        groupedKey,
        primaryKeyName,
        blockName,
      })
    },
    itemsGroupedByDanger() {
      let groupedKey = 'danger'
      let primaryKeyName = 'fkko_id'
      let data = this.items.data
      let searchFoundedItemsIds = this.searchFoundedItemsIds
      let blockName = (current) =>
        'Класс опасности ' + (current.danger || 'не указан')
      return this.groupItems(data, searchFoundedItemsIds, {
        groupedKey,
        primaryKeyName,
        blockName,
      })
    },
    itemsGroupedByGarbageType() {
      let groupedKey = 'type_name'
      let primaryKeyName = 'type_id'
      let data = this.items.data
      let searchFoundedItemsIds = this.searchFoundedItemsIds
      let blockName = (current) => current.type_name
      return this.groupItems(data, searchFoundedItemsIds, {
        groupedKey,
        primaryKeyName,
        blockName,
      })
    },
    // old format
    metaFields() {
      return {
        block: { sortable: false, label: 'Блок' },
        danger: { sortable: true, label: 'Класс опасности' },
        state: { sortable: true, label: 'Агрегатное состояние' },
        composition: { sortable: true, label: 'Состав' },
        production: { sortable: true, label: 'Производство' },
        tech_process: { sortable: true, label: 'Технологический процесс' },
        formed: { sortable: true, label: 'Образование' },
        util: { sortable: true, label: 'Утилизация' },
        neutral: { sortable: true, label: 'Обезвреживание' },
        store: { sortable: true, label: 'Хранение' },
        burial: { sortable: true, label: 'Захоронение' },
      }
    },
    /* данные из поиска */
    searchFoundedItems() {
      return this.$store.getters.readUrlEndpoint(
        this.getSearchEndpoint(this.$route)
      )
    },
    items() {
      let tmp =
        this.$store.getters.readUrlEndpoint(this.getEndpoint(this.$route)) || {}
      // generate id for vue can use key
      // in render table nodes
      if (tmp.data) {
        tmp.data.forEach((v, i) => {
          if (!v.id) {
            tmp.data[i].id = v.fkko_id
          }
        })
      }
      if (!(tmp._meta && tmp._meta.fields)) {
        console.warn('old format, meta from server not used')
        tmp._meta = { fields: this.metaFields }
      }
      return tmp
    },
    typeItems() {
      const items = {}
      if (this.filterModel._groupBy === GROUP_BY_GARBAGE_TYPE) {
        this.items.data.forEach((item) => {
          if (!items[item.type_name]) {
            items[item.type_name] = {
              children: [item],
              type_id: item.type_id,
            }
          } else {
            items[item.type_name].children.push(item)
          }
        })
      }
      Object.values(items).forEach((item) => {
        const children = {}
        item.children.forEach((el) => {
          const data = {}
          Object.keys(this.items._meta.fields).forEach((item) => {
            Object.keys(el).forEach((key) => {
              if (key === item) {
                if (!data[item]) {
                  data[item] = el[key]
                }
              }
            })
          })
          data['fkko_name'] = el.fkko_name
          data['fkko_code'] = el.fkko_code
          data['reg_code'] = el.reg_code
          if (!children[el.fkko_group_name]) {
            children[el.fkko_group_name] = {
              children: [data],
              percent: this.calculatePercentGarbageByType(
                item.type_id,
                el.fkko_group_id
              ),
            }
          } else {
            children[el.fkko_group_name].children.push(data)
          }
        })
        item.children = children
      })
      const data = { ...this.items }
      data.data = items
      return data
    },
  },
  watch: {
    $route: 'setFiltersFromUrl',
  },
  methods: {
    groupItems(
      data = [],
      searchFoundedItemsIds = [],
      { groupedKey, primaryKeyName, blockName }
    ) {
      this.filterModel.groupContextAttr = groupedKey
      if (!blockName) {
        blockName = () => ' - '
      }
      let rows = []
      for (let i = 0; i < data.length; i++) {
        let current = data[i]
        if (
          searchFoundedItemsIds.length > 0 &&
          searchFoundedItemsIds.indexOf(current[primaryKeyName]) === -1
        ) {
          continue
        }
        let groupAddedEarly = rows.findIndex((v) => {
          return !!(v && v._isBlock && v[groupedKey] === current[groupedKey])
        })
        if (groupAddedEarly > -1) {
          continue
        }
        // great groups
        rows.push({
          id: 'g' + current[primaryKeyName],
          block: blockName(current),
          groupedKey,
          [groupedKey]: current[groupedKey],
          _isBlock: true,
        })
        let isAddedEarly = rows.findIndex(
          (v) => v[primaryKeyName] === current[primaryKeyName]
        )
        if (isAddedEarly > -1) {
          continue
        }
        // find items of that group
        data.forEach((searched) => {
          if (
            this.openedRows.indexOf(searched[groupedKey]) > -1 &&
            searched[groupedKey] === current[groupedKey]
          ) {
            if (
              searchFoundedItemsIds.length > 0 &&
              searchFoundedItemsIds.indexOf(searched[primaryKeyName]) === -1
            ) {
              // todo convert to for
            } else {
              rows.push(searched)
            }
          }
        })
      }
      if (!this.$route.query.sort) {
        rows.sort((a, b) => a.fkko_group_id - b.fkko_group_id)
      }
      return rows
    },
    setFiltersFromUrl() {
      let route = url.getRoute(this.$route)
      if (route.query._groupBy) {
        this.filterModel._groupBy = route.query._groupBy
      }
    },
    changeGroupedBy() {
      let route = url.getRoute(this.$route)
      route.query._groupBy = this.filterModel._groupBy
      if (route.query._groupBy === GROUP_BY_GARBAGE_TYPE) {
        this.filterModel.groupContextAttr = 'type_id'
      }
      if (route.query._groupBy === GROUP_BY_FKKO) {
        route.query.sort = 'fkko_code'
      }
      if (route.query._groupBy === GROUP_BY_DANGER) {
        route.query.sort = 'danger'
      }
      this.$router.push(route)
    },
    trClass(row) {
      let cssClass = 'table__row_padding '
      let groupKey = this.getGroupedKey(row)
      if (row && row._isBlock) {
        cssClass += 'first-level'
      } else {
        cssClass += 'second-level'
      }
      if (this.openedRows.indexOf(row[groupKey]) > -1) {
        cssClass += ' opened '
      } else {
        cssClass += ' closed '
      }
      return cssClass
    },
    fullWidthTr(row) {
      if (row && row._isBlock) {
        return 1
      }
      return 0
    },
    getGroupedKey(row) {
      return row.groupedKey || 'fkko_group_id'
    },
    toggleBlock(row) {
      let groupKey = this.getGroupedKey(row)
      if (this.openedRows.indexOf(row[groupKey]) > -1) {
        this.openedRows = this.openedRows.filter((v) => v !== row[groupKey])
      } else {
        this.openedRows.push(row[groupKey])
      }
    },
    getSearchEndpoint(route) {
      if (route.query.q) {
        return cadastr.garbageSearch(route)
      } else {
        return null
      }
    },
    getEndpoint(route) {
      // всегда передавать сортировку, иначе придется два формата данных поддерживать
      let copyRoute = url.getRoute(route)
      if (!copyRoute.query.sort) {
        copyRoute.query.sort = 'id'
      }
      delete copyRoute.query.q

      return cadastr.garbage(copyRoute)
    },
    calculatePercentGarbageByType(groupId, fkko_group_id) {
      const items = this.items.data.filter(
        (item) => item['type_id'] === groupId
      )
      const commonValue = items.reduce((acc, item) => {
        acc += Number(item.start_year_value)
        return acc
      }, 0)
      const groupedItems = items.filter(
        (item) => item['fkko_group_id'] === fkko_group_id
      )
      const value = groupedItems.reduce((acc, item) => {
        acc += Number(item.start_year_value)
        return acc
      }, 0)
      let percent = 100
      if (commonValue > 0) {
        percent = ((value / commonValue) * 100).toFixed(2)
      }
      return `<span>${percent}% от совокупного количества отходов на начало года</span>`
    },
    calculatePercentGarbage(groupId) {
      const commonValue = this.items.data.reduce((acc, item) => {
        acc += Number(item.start_year_value)
        return acc
      }, 0)
      const groupedItems = this.items.data.filter(
        (item) => item[this.filterModel.groupContextAttr] === groupId
      )
      const value = groupedItems.reduce((acc, item) => {
        acc += Number(item.start_year_value)
        return acc
      }, 0)
      let percent = 100
      if (commonValue > 0) {
        percent = ((value / commonValue) * 100).toFixed(2)
      }
      return `<span>${percent}% от совокупного количества отходов на начало года</span>`
    },
  },
  created() {
    this.setFiltersFromUrl()
  },
  asyncData({ store, route, fromRoute, methods }) {
    let promises = []

    if (methods.getSearchEndpoint(route)) {
      promises.push(
        store.dispatch('updateUrlEndpoint', {
          endpoint: methods.getSearchEndpoint(route),
        })
      )
    }

    promises.push(
      store.dispatch('updateUrlEndpoint', {
        endpoint: methods.getEndpoint(route, fromRoute),
      })
    )

    return Promise.all(promises)
  },
}
</script>
<style lang="scss">
.garbage {
  .toolbar__line {
    align-items: flex-end;
  }
}
</style>
